import Vue from 'vue/dist/vue.esm';
import { AxiosApiClient } from '../utilities/axios_api_client';
import vEmbeddedMap from '../components/embedded_map';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  position: 'top-center'
});

document.addEventListener("DOMContentLoaded", () => {
  var element = document.getElementById('embedded_map_vue_wrapper');

  Vue.prototype.$axios = AxiosApiClient;
  Vue.prototype.$gtag = window.gtag;
  Vue.prototype.$sentry = Sentry;

  if (window.sentryDSN) {
    Sentry.init({
      Vue,
      dsn: window.sentryDSN,
      integrations: [
        new BrowserTracing({
          tracingOrigins: ["localhost", "www.hellodrifter.com", /^\//],
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.5,
    });
  }

  new Vue({
    el: element,
    components: { vEmbeddedMap }
  });
});
